import React from 'react';
import ProjectContainer from '../../containers/techmng/ProjectContainer';

const TechProjectDetailPage = () => {
  return <ProjectContainer />
};

export default TechProjectDetailPage;
